import React, { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useFetch } from '../../../components/component-items/helpers'
import ImageZoom from 'react-medium-image-zoom'
import CardLoading from '../../../components/component-items/loading-popover'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight, faPrint } from '@fortawesome/pro-duotone-svg-icons'
import useEmblaCarousel from 'embla-carousel-react'
import { LabelStyled } from './styles'

export const Slips = () => {
  const { id: order } = useParams<{ id: string }>()
  const url = `/api/order/${order}/slips/`
  const { response: resp, loaded, error, placeholder }: any = useFetch(url, {})

  const slips: string[] = loaded ? resp.slips || [] : []
  const print = loaded ? resp.print : false
  const total = slips.length

  // Initialize Embla Carousel
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: 'center' })

  const [currentSlide, setCurrentSlide] = useState(0)

  // Track current slide
  useEffect(() => {
    if (!emblaApi) return

    const onSelect = () => {
      setCurrentSlide(emblaApi.selectedScrollSnap())
    }

    emblaApi.on('select', onSelect)
    onSelect() // set initial slide immediately

    // ✅ Clean up safely when emblaApi changes or component unmounts
    return () => {
      emblaApi.off('select', onSelect)
    }
  }, [emblaApi])

  const handlePrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi])
  const handleNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi])

  return (
    <LabelStyled>
      <div className="datatable__header">
        <div className="datatable__title">
          <h3>Labels and Packslips</h3>
          <div>
            {print && (
              <a href={print} style={{ paddingRight: '5px' }}>
                <FontAwesomeIcon icon={faPrint} />
              </a>
            )}
            {total > 1 && (
              <>
                <button onClick={handlePrev}>
                  <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <button onClick={handleNext}>
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="order-section embla" ref={emblaRef}>
        <div className="embla__container">
          {total > 0 ? (
            slips.map((img, id) => (
              <div className="embla__slide" key={id}>
                <ImageZoom>
                  <img src={img} alt="Slip" className="img" />
                </ImageZoom>
              </div>
            ))
          ) : (
            <div className="no-label">
              <div role="img" aria-label="none">
                🏷
              </div>
              No Shipping Labels
            </div>
          )}
        </div>
      </div>

      {!loaded && <CardLoading text={placeholder} error={error} />}
    </LabelStyled>
  )
}
